import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-dark py-10 md:py-12 px-4 md:px-6" data-id="element-123">
      <div className="max-w-4xl mx-auto text-center" data-id="element-124">
        <h3 className="text-xl md:text-2xl font-display font-bold text-gold-accent mb-2 md:mb-3" data-id="element-125">
          SIATKÓWKA GOTOWA: SYSTEM 365
        </h3>
        <p className="text-sm md:text-base text-[#9BA3B5] mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-126">
          Najlepszy sposób na prowadzenie zajęć siatkówki bez przygotowywania
          wszystkiego od zera.
          <br className="hidden sm:block" data-id="element-127" />
          Narzędzia które naprawdę działają dla nauczycieli którzy chcą
          konkretnych wyników.
        </p>
        <div className="border-t border-[#1E3A5F] pt-6 md:pt-8" data-id="element-128">
          <p className="text-xs md:text-sm text-[#9BA3B5] mb-1 md:mb-2" data-id="element-129">
            © 2026 — Wszelkie prawa zastrzeżone
          </p>
          <p className="text-xs md:text-sm text-[#1E3A5F]" data-id="element-130">
            Produkt cyfrowy — PDF do natychmiastowego pobrania
          </p>
        </div>
      </div>
    </footer>;
}